import { DataModel } from "common/models/utility-models/base-model";

export class CompanyMentorModel extends DataModel {
    companyName: any = '';
    mentorName: any = '';
    mentorEmail: any = '';
    mentorMobile: any = '';
    mentorDepartment: any = '';
    mentorRole: any = '';
    mentorCity: any = '';
}